export const translations = {
  en: {
    // Navigation
    "nav.newStudy": "New Study",
    "nav.back": "Back",
    "setup.back": "Back",
    
    // Landing Page
    "landing.badge": "AI-Powered Consumer Research",
    "landing.title1": "Understand Your Customers",
    "landing.title2": "Before They Exist",
    "landing.subtitle": "Generate realistic AI personas based on your target demographics and query them for instant market research insights. No focus groups required.",
    "landing.getStarted": "Get Started",
    "landing.watchDemo": "Watch Demo",
    "landing.feature1.title": "AI-Generated Personas",
    "landing.feature1.desc": "Create diverse, realistic consumer personas based on your target demographics",
    "landing.feature2.title": "Query Your Audience",
    "landing.feature2.desc": "Ask questions and receive authentic responses from your virtual focus group",
    "landing.feature3.title": "Aggregated Insights",
    "landing.feature3.desc": "Get sentiment analysis and key themes from all persona responses",
    "landing.samplePanel": "Sample Persona Panel",
    "landing.sampleQuery": "Sample Query",
    "landing.footer": "AI-powered consumer research",
    "landing.builtWith": "Built with Claude Sonnet 4.5",
    
    // Setup Page
    "setup.title": "Configure Your Target Group",
    "setup.subtitle": "Define your target audience parameters to generate realistic personas",
    "setup.studyName": "Study Name",
    "setup.studyNamePlaceholder": "e.g., Q1 2025 Product Research",
    "setup.targetGenerations": "Target Generations",
    "setup.ageRange": "Age range",
    "setup.born": "Born",
    "setup.yearsOld": "years old",
    "setup.gender": "Gender",
    "setup.male": "Male",
    "setup.female": "Female",
    "setup.other": "Other",
    "setup.country": "Country",
    "setup.selectCountry": "Select a country",
    "setup.industry": "Industry / Target Context",
    "setup.selectIndustry": "Select an industry",
    "setup.numberOfPersonas": "Number of Personas",
    "setup.generatePersonas": "Generate Personas",
    "setup.creating": "Creating...",
    "setup.selectGeneration": "Please select at least one generation",
    "setup.selectGender": "Please select at least one gender",
    "setup.selectCountryError": "Please select a country",
    "setup.selectIndustryError": "Please select an industry",
    "setup.enterName": "Please enter a name for your study",
    "setup.success": "Target group created! Generating personas...",
    "setup.error": "Failed to create target group. Please try again.",
    
    // Error messages
    "setup.errors.selectGeneration": "Please select at least one generation",
    "setup.errors.selectGender": "Please select at least one gender",
    "setup.errors.selectCountry": "Please select a country",
    "setup.errors.selectIndustry": "Please select an industry",
    "setup.errors.enterName": "Please enter a name for your study",
    "setup.errors.failed": "Failed to create target group. Please try again.",
    
    // Dashboard Page
    "dashboard.generatingPersonas": "Generating Personas...",
    "dashboard.created": "created",
    "dashboard.starting": "Starting...",
    "dashboard.personas": "Personas",
    "dashboard.queryResults": "Query Results",
    "dashboard.askQuestion": "Ask your personas a question...",
    "dashboard.query": "Query",
    "dashboard.noQueries": "No queries yet",
    "dashboard.noPersonas": "No personas generated yet",
    "dashboard.askQuestionHint": "Ask a question above to see how your personas respond",
    "dashboard.waitForPersonas": "Wait for personas to finish generating, then ask a question",
    "dashboard.queryCompleted": "Query completed!",
    "dashboard.queryFailed": "Failed to query personas",
    
    // Persona Card & Details
    "persona.generating": "Generating...",
    "persona.occupation": "Occupation",
    "persona.location": "Location",
    "persona.education": "Education",
    "persona.intelligence": "Intelligence",
    "persona.family": "Family",
    "persona.income": "Income",
    "persona.personalityTraits": "Personality Traits",
    "persona.interests": "Interests",
    "persona.values": "Values",
    "persona.painPoints": "Pain Points",
    "persona.goals": "Goals",
    "persona.buyingBehavior": "Buying Behavior",
    "persona.techSavviness": "Tech Savviness",
    
    // Education levels
    "education.high_school": "High School",
    "education.vocational": "Vocational",
    "education.bachelors": "Bachelor's",
    "education.masters": "Master's",
    "education.phd": "PhD",
    "education.self_taught": "Self-taught",
    "education.unknown": "Unknown",
    
    // Intelligence levels
    "intelligence.below_average": "Below Average",
    "intelligence.average": "Average",
    "intelligence.above_average": "Above Average",
    "intelligence.gifted": "Gifted",
    
    // Family situations
    "family.single": "Single",
    "family.married_no_kids": "Married, No Kids",
    "family.married_with_kids": "Married with Kids",
    "family.single_parent": "Single Parent",
    "family.divorced": "Divorced",
    "family.living_with_parents": "Living with Parents",
    "family.unknown": "Unknown",
    
    // Income levels
    "income.low": "Low",
    "income.lower_middle": "Lower Middle",
    "income.middle": "Middle",
    "income.upper_middle": "Upper Middle",
    "income.high": "High",
    
    // Tech savviness
    "tech.low": "Low",
    "tech.medium": "Medium",
    "tech.high": "High",
    
    // Countries
    "country.label": "Country",
    "country.select": "Select a country",
    
    // Industries
    "industry.label": "Industry / Target Context",
    "industry.select": "Select an industry",
    
    // Query Results
    "query.summary": "Summary",
    "query.individual": "Individual",
    "query.executiveSummary": "Executive Summary",
    "query.keyThemes": "Key Themes",
    "query.sentimentBreakdown": "Sentiment Breakdown",
    "query.positive": "Positive",
    "query.negative": "Negative",
    "query.neutral": "Neutral",
    "query.mixed": "Mixed",
    
    // Future Prediction
    "future.title": "Time Horizon",
    "future.now": "Now",
    "future.years": "years",
    "future.yearsFuture": "years into future",
    "future.scenario": "World Scenario",
    "future.optimistic": "Optimistic",
    "future.normal": "Normal",
    "future.pessimistic": "Pessimistic",
    "future.scenarioDetails": "Future Scenario Details",
    "future.worldOverview": "World in",
    "future.economicOutlook": "Economic Outlook",
    "future.technologyTrends": "Technology Trends",
    "future.socialChanges": "Social Changes",
    "future.industryDisruptions": "Industry Disruptions",
    "future.environmentalFactors": "Environmental Factors",
    "future.politicalLandscape": "Political Landscape",
    "future.keyOpportunities": "Key Opportunities",
    "future.keyChallenges": "Key Challenges",
    "future.consumerBehavior": "Consumer Behavior Shifts",
    "future.personaEvolution": "How They've Changed",
    "future.lifeChanges": "Life Changes",
    "future.careerEvolution": "Career Evolution",
    "future.financialSituation": "Financial Situation",
    "future.valuesShift": "Values & Priorities",
    "future.techAdoption": "Tech Adoption",
    "future.challengesFaced": "Challenges Faced",
    "future.ageIn": "Age in",
  },
  
  de: {
    // Navigation
    "nav.newStudy": "Neue Studie",
    "nav.back": "Zurück",
    "setup.back": "Zurück",
    
    // Landing Page
    "landing.badge": "KI-gestützte Verbraucherforschung",
    "landing.title1": "Verstehen Sie Ihre Kunden",
    "landing.title2": "Bevor sie existieren",
    "landing.subtitle": "Erstellen Sie realistische KI-Personas basierend auf Ihrer Zielgruppe und befragen Sie diese für sofortige Marktforschungserkenntnisse. Keine Fokusgruppen erforderlich.",
    "landing.getStarted": "Jetzt starten",
    "landing.watchDemo": "Demo ansehen",
    "landing.feature1.title": "KI-generierte Personas",
    "landing.feature1.desc": "Erstellen Sie vielfältige, realistische Verbraucher-Personas basierend auf Ihrer Zielgruppe",
    "landing.feature2.title": "Befragen Sie Ihr Publikum",
    "landing.feature2.desc": "Stellen Sie Fragen und erhalten Sie authentische Antworten von Ihrer virtuellen Fokusgruppe",
    "landing.feature3.title": "Aggregierte Erkenntnisse",
    "landing.feature3.desc": "Erhalten Sie Sentiment-Analysen und Kernthemen aus allen Persona-Antworten",
    "landing.samplePanel": "Beispiel Persona-Panel",
    "landing.sampleQuery": "Beispiel-Abfrage",
    "landing.footer": "KI-gestützte Verbraucherforschung",
    "landing.builtWith": "Erstellt mit Claude Sonnet 4.5",
    
    // Setup Page
    "setup.title": "Zielgruppe konfigurieren",
    "setup.subtitle": "Definieren Sie Ihre Zielgruppen-Parameter für realistische Personas",
    "setup.studyName": "Studienname",
    "setup.studyNamePlaceholder": "z.B. Q1 2025 Produktforschung",
    "setup.targetGenerations": "Ziel-Generationen",
    "setup.ageRange": "Altersbereich",
    "setup.born": "Geboren",
    "setup.yearsOld": "Jahre alt",
    "setup.gender": "Geschlecht",
    "setup.male": "Männlich",
    "setup.female": "Weiblich",
    "setup.other": "Divers",
    "setup.country": "Land",
    "setup.selectCountry": "Land auswählen",
    "setup.industry": "Branche / Zielkontext",
    "setup.selectIndustry": "Branche auswählen",
    "setup.numberOfPersonas": "Anzahl der Personas",
    "setup.generatePersonas": "Personas generieren",
    "setup.creating": "Wird erstellt...",
    "setup.selectGeneration": "Bitte wählen Sie mindestens eine Generation",
    "setup.selectGender": "Bitte wählen Sie mindestens ein Geschlecht",
    "setup.selectCountryError": "Bitte wählen Sie ein Land",
    "setup.selectIndustryError": "Bitte wählen Sie eine Branche",
    "setup.enterName": "Bitte geben Sie einen Namen für Ihre Studie ein",
    "setup.success": "Zielgruppe erstellt! Personas werden generiert...",
    "setup.error": "Fehler beim Erstellen der Zielgruppe. Bitte versuchen Sie es erneut.",
    
    // Error messages
    "setup.errors.selectGeneration": "Bitte wählen Sie mindestens eine Generation",
    "setup.errors.selectGender": "Bitte wählen Sie mindestens ein Geschlecht",
    "setup.errors.selectCountry": "Bitte wählen Sie ein Land",
    "setup.errors.selectIndustry": "Bitte wählen Sie eine Branche",
    "setup.errors.enterName": "Bitte geben Sie einen Namen für Ihre Studie ein",
    "setup.errors.failed": "Fehler beim Erstellen der Zielgruppe. Bitte versuchen Sie es erneut.",
    
    // Dashboard Page
    "dashboard.generatingPersonas": "Personas werden generiert...",
    "dashboard.created": "erstellt",
    "dashboard.starting": "Wird gestartet...",
    "dashboard.personas": "Personas",
    "dashboard.queryResults": "Abfrage-Ergebnisse",
    "dashboard.askQuestion": "Stellen Sie Ihren Personas eine Frage...",
    "dashboard.query": "Abfragen",
    "dashboard.noQueries": "Noch keine Abfragen",
    "dashboard.noPersonas": "Noch keine Personas generiert",
    "dashboard.askQuestionHint": "Stellen Sie oben eine Frage, um zu sehen, wie Ihre Personas antworten",
    "dashboard.waitForPersonas": "Warten Sie, bis die Personas fertig sind, dann stellen Sie eine Frage",
    "dashboard.queryCompleted": "Abfrage abgeschlossen!",
    "dashboard.queryFailed": "Fehler bei der Persona-Abfrage",
    
    // Persona Card & Details
    "persona.generating": "Wird generiert...",
    "persona.occupation": "Beruf",
    "persona.location": "Standort",
    "persona.education": "Bildung",
    "persona.intelligence": "Intelligenz",
    "persona.family": "Familie",
    "persona.income": "Einkommen",
    "persona.personalityTraits": "Persönlichkeitsmerkmale",
    "persona.interests": "Interessen",
    "persona.values": "Werte",
    "persona.painPoints": "Schmerzpunkte",
    "persona.goals": "Ziele",
    "persona.buyingBehavior": "Kaufverhalten",
    "persona.techSavviness": "Technische Kompetenz",
    
    // Education levels
    "education.high_school": "Abitur",
    "education.vocational": "Berufsausbildung",
    "education.bachelors": "Bachelor",
    "education.masters": "Master",
    "education.phd": "Doktorat",
    "education.self_taught": "Autodidakt",
    "education.unknown": "Unbekannt",
    
    // Intelligence levels
    "intelligence.below_average": "Unterdurchschnittlich",
    "intelligence.average": "Durchschnittlich",
    "intelligence.above_average": "Überdurchschnittlich",
    "intelligence.gifted": "Hochbegabt",
    
    // Family situations
    "family.single": "Alleinstehend",
    "family.married_no_kids": "Verheiratet, keine Kinder",
    "family.married_with_kids": "Verheiratet mit Kindern",
    "family.single_parent": "Alleinerziehend",
    "family.divorced": "Geschieden",
    "family.living_with_parents": "Bei Eltern lebend",
    "family.unknown": "Unbekannt",
    
    // Income levels
    "income.low": "Niedrig",
    "income.lower_middle": "Untere Mittelschicht",
    "income.middle": "Mittelschicht",
    "income.upper_middle": "Obere Mittelschicht",
    "income.high": "Hoch",
    
    // Tech savviness
    "tech.low": "Niedrig",
    "tech.medium": "Mittel",
    "tech.high": "Hoch",
    
    // Countries
    "country.label": "Land",
    "country.select": "Land auswählen",
    
    // Industries
    "industry.label": "Branche / Zielkontext",
    "industry.select": "Branche auswählen",
    
    // Query Results
    "query.summary": "Zusammenfassung",
    "query.individual": "Einzeln",
    "query.executiveSummary": "Zusammenfassung",
    "query.keyThemes": "Kernthemen",
    "query.sentimentBreakdown": "Stimmungsaufteilung",
    "query.positive": "Positiv",
    "query.negative": "Negativ",
    "query.neutral": "Neutral",
    "query.mixed": "Gemischt",
    
    // Future Prediction
    "future.title": "Zeithorizont",
    "future.now": "Jetzt",
    "future.years": "Jahre",
    "future.yearsFuture": "Jahre in der Zukunft",
    "future.scenario": "Weltszenario",
    "future.optimistic": "Optimistisch",
    "future.normal": "Normal",
    "future.pessimistic": "Pessimistisch",
    "future.scenarioDetails": "Zukunftsszenario Details",
    "future.worldOverview": "Die Welt im Jahr",
    "future.economicOutlook": "Wirtschaftliche Aussichten",
    "future.technologyTrends": "Technologietrends",
    "future.socialChanges": "Gesellschaftliche Veränderungen",
    "future.industryDisruptions": "Branchenumwälzungen",
    "future.environmentalFactors": "Umweltfaktoren",
    "future.politicalLandscape": "Politische Landschaft",
    "future.keyOpportunities": "Wichtige Chancen",
    "future.keyChallenges": "Wichtige Herausforderungen",
    "future.consumerBehavior": "Veränderungen im Konsumverhalten",
    "future.personaEvolution": "Wie sie sich verändert haben",
    "future.lifeChanges": "Lebensveränderungen",
    "future.careerEvolution": "Karriereentwicklung",
    "future.financialSituation": "Finanzielle Situation",
    "future.valuesShift": "Werte & Prioritäten",
    "future.techAdoption": "Technologie-Nutzung",
    "future.challengesFaced": "Bewältigte Herausforderungen",
    "future.ageIn": "Alter im Jahr",
  }
};

export default translations;
